import { createRoutine } from 'redux-saga-routines';
import { GET_COMPOSER_LIST, GET_COMPOSER_SEARCH_LIST, CLEAR_COMPOSER_SEARCH_LIST } from './constants';

export const getComposerListAction = createRoutine(GET_COMPOSER_LIST);
export const getComposerSearchListAction = createRoutine(GET_COMPOSER_SEARCH_LIST);
export const clearComposersSearchAction = createRoutine(CLEAR_COMPOSER_SEARCH_LIST);
